import Client from '../client';
import {flattenObject} from '../helpers';

import {
  GetAllCentersRequestBuilder,
  GetCentersCountRequestBuilder,
  UpdateCenterRequestBuilder,
  CreateCenterRequestBuilder,
  UpdateCenterStatusRequestBuilder,
  GetAllCentersReportRequestBuilder,
  GetAllCenterStaristicsRequestBuilder,
} from '../centers/centers';
const token = localStorage.getItem('token') || '';

class CentersRepository {
  getCenters = async (actions: any) => {
    const makeRequest = new GetAllCentersRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();
    const makeCountRequest = new GetCentersCountRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    const count = await client.execute(makeCountRequest);
    return {response, count};
  };
  getCentersWithId = async (actions: any) => {
    const makeRequest = new GetAllCentersRequestBuilder()
      .id(actions.payload.id)
      .build();
    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
  updateCenter = async (actions: any) => {
    const {body, pagination, id} = actions.payload;
    const makeUpdateRequest = new UpdateCenterRequestBuilder()
      .data(body)
      .build();
    const client = new Client(token);
    await client.execute(makeUpdateRequest);
    return {pagination, id};
  };
  createCenter = async (actions: any) => {
    const {body, pagination, id, callback} = actions.payload;
    const makeRequest = new CreateCenterRequestBuilder().data(body).build();
    const client = new Client(token);
    await client.execute(makeRequest);
    return {pagination, callback, id};
  };
  updateCenterAdmin = async (actions: any) => {
    const {body, pagination, id} = actions.payload;
    const makeUpdatRequest = new UpdateCenterRequestBuilder()
      .id(id)
      .data(body)
      .build();

    const client = new Client(token);
    await client.execute(makeUpdatRequest);
    return pagination;
  };
  getAllCentersReport = async (actions: any) => {
    const makeRequest = new GetAllCentersReportRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
  updateCenterStatus = async (actions: any) => {
    const {id, body, pagination} = actions.payload;
    const makeUpdateStatusRequest = new UpdateCenterStatusRequestBuilder()
      .id(id)
      .data(body)
      .build();
    const client = new Client(token);
    await client.execute(makeUpdateStatusRequest);
    return pagination;
  };
  getCentersActiveCount = async (actions: any) => {
    const {filters, callback} = actions.payload;
    const makeCountRequest = new GetCentersCountRequestBuilder()
      .params(flattenObject({...filters, sort: 'id,desc'}))
      .build();

    const client = new Client(token);
    const count = await client.execute(makeCountRequest);
    return {count, callback};
  };
  getCentersDeactiveCount = async (actions: any) => {
    const {filters, callback} = actions.payload;
    const makeCountRequest = new GetCentersCountRequestBuilder()
      .params(flattenObject({...filters, sort: 'id,desc'}))
      .build();

    const client = new Client(token);
    const count = await client.execute(makeCountRequest);
    return {count, callback};
  };
  getCenterStatistics = async (actions: any) => {
    const makeRequest = new GetAllCenterStaristicsRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();
    const makeCountRequest = new GetCentersCountRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
  getCenterStatisticWithId = async (actions: any) => {
    const makeRequest = new GetAllCenterStaristicsRequestBuilder()
      .id(actions.payload.id)
      .params(
        flattenObject({
          ...actions.payload?.pagination,
          sort: 'id,desc',
        })
      )

      .build();
    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
}

export default new CentersRepository();
